module.exports = __webpack_public_path__ + "img/remove-skill-star.3c969e9b.svg";